import { f as r, p as u } from "./immer-4e3ccba6.js";
import { useState as f, useCallback as i } from "react";
function a(o) {
  var n = f(function() {
    return r(typeof o == "function" ? o() : o, !0);
  }), t = n[1];
  return [n[0], i(function(e) {
    t(typeof e == "function" ? u(e) : r(e));
  }, [])];
}
export {
  a as i
};
